import Swiper from "swiper";

/**
 * Valori slidesPerView per ogni breakpoint.
 * Tutti i campi sono opzionali: se omessi viene usato il valore di default.
 */
export interface SwiperBreakpointSlides {
    /** < 480px  — default: 1 */
    base?: number;
    /** >= 480px — default: 1 */
    bp480?: number;
    /** >= 576px — default: 1.75 */
    bp576?: number;
    /** >= 768px — default: 2.25 */
    bp768?: number;
    /** >= 992px — default: 3 */
    bp992?: number;
    /** >= 1200px — default: 4 */
    bp1200?: number;
    /** >= 1400px — default: 4 */
    bp1400?: number;
}

/**
 * Inizializza uno Swiper con la configurazione standard a breakpoint.
 *
 * @param selector  - Selettore CSS o elemento HTML del container Swiper
 * @param slides    - Override opzionale dei valori slidesPerView per breakpoint
 */
export function initSwiperCarousel(
    selector: string | HTMLElement,
    slides: SwiperBreakpointSlides = {},
    autoplay: boolean = false
): Swiper | null {
    const el = typeof selector === "string"
        ? document.querySelector<HTMLElement>(selector)
        : selector;

    if (!el) return null;

    const {
        base  = 1,
        bp480  = 1,
        bp576  = 1.75,
        bp768  = 2.25,
        bp992  = 3,
        bp1200 = 4,
        bp1400 = 4,
    } = slides;

    return new Swiper(el, {
        slidesPerView: base,
        spaceBetween: 16,
        autoplay: autoplay,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            bulletClass: "swiper-pagination-bullet swiper-pagination-bullet--light",
        },
        breakpoints: {
            480:  { slidesPerView: bp480,  spaceBetween: 16 },
            576:  { slidesPerView: bp576,  spaceBetween: 16 },
            768:  { slidesPerView: bp768,  spaceBetween: 16 },
            992:  { slidesPerView: bp992,  spaceBetween: 16 },
            1200: { slidesPerView: bp1200, spaceBetween: 16 },
            1400: { slidesPerView: bp1400, spaceBetween: 16 },
        },
    });
}



